import { render, staticRenderFns } from "./InputSemantico.vue?vue&type=template&id=96766f54"
import script from "./InputSemantico.vue?vue&type=script&lang=js"
export * from "./InputSemantico.vue?vue&type=script&lang=js"
import style0 from "./InputSemantico.vue?vue&type=style&index=0&id=96766f54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports